import {
  INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
  TOGGLE_SPAM_FF_REQUEST_ASYNC,
  UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC,
} from './constants'

const getIntelligenceSettings = () => ({
  type: INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE,
})
export const getIntelligenceSettingsSuccess = (data) => ({
  type: INTELLIGENCE_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getIntelligenceSettingsError = (error) => ({
  type: INTELLIGENCE_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const getIntelligenceSettingsCancel = () => ({
  type: INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const updIntelligenceSettings = () => ({
  type: UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.INITIATE,
})
export const updIntelligenceSettingsSuccess = (data) => ({
  type: UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const updIntelligenceSettingsError = (error) => ({
  type: UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const updIntelligenceSettingsCancel = () => ({
  type: UPDATE_INTELLIGENCE_SETTINGS_REQUEST_ASYNC.CANCEL,
})

const toggleSpamFF = (ffState) => ({
  type: TOGGLE_SPAM_FF_REQUEST_ASYNC.INITIATE,
  payload: { ffState },
})

export const toggleSpamFFSuccess = () => ({
  type: TOGGLE_SPAM_FF_REQUEST_ASYNC.SUCCESS,
})

export default {
  // to props
  getIntelligenceSettings,
  getIntelligenceSettingsCancel,
  updIntelligenceSettings,
  updIntelligenceSettingsCancel,
  toggleSpamFF,
}
